import $ from 'jquery';

$(function() {
    $('.process-step').on('click', function (e) {
        e.preventDefault();
        $('.process-step').removeClass('active');
        $(this).addClass('active');
    });
    $(document).mouseup(function (e) {
        const container = $('.process-step');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.process-step').removeClass('active');
        }
    });
});
